module.exports = __webpack_public_path__ + "fonts/GothamSSm-Medium_Web.c328510.woff";